<div class="flex flex-col lg:px-32 py-12 bg-white">
    <h1 class="text-2xl font-bold">Privacy Policy</h1>
    <p class="text-sm text-gray-600">November 2021 | Version 1.0</p>

    <h2 class="text-2xl font-semibold mt-6">1. Introduction</h2>
    <p>We are Regarding My Life (Registration number 2020/796651/07) and this policy is our plan of action to protect
        your privacy.</p>
    <p>We respect your privacy and take the protection of personal information seriously. The purpose of this policy is
        to describe the way that we collect, store, use, and protect information that can be associated with you or
        another specific natural or juristic person and can be used to identify you or that person (personal
        information).</p>

    <h2 class="text-2xl font-semibold mt-6">2. Audience</h2>
    <p>This policy applies to you if you are:</p>
    <ul class="list-disc list-inside ml-4">
        <li>a visitor to our website;</li>
        <li>a registered user on our website; or</li>
        <li>a prospect or customer who has ordered or requested the goods or services that we provide.</li>
    </ul>

    <h2 class="text-2xl font-semibold mt-6">3. What is personal information?</h2>
    <p>Personal information includes:</p>
    <ul class="list-disc list-inside ml-4">
        <li>certain information that we collect automatically when you visit our website;</li>
        <li>certain information collected on registration (see below);</li>
        <li>certain information collected on submission; and</li>
        <li>optional information that you provide to us voluntarily (see below);</li>
    </ul>
    <p>but excludes:</p>
    <ul class="list-disc list-inside ml-4">
        <li>information that has been made anonymous so that it does not identify a specific person;</li>
        <li>permanently de-identified information that does not relate or cannot be traced back to you specifically; and
        </li>
        <li>non-personal statistical information collected and compiled by us.</li>
    </ul>
    <p>Common examples of the personal information that we may collect and process include your:</p>
    <ul class="list-disc list-inside ml-4">
        <li>identifying information – such as your name, date of birth, or identification number of any kind;</li>
        <li>contact information – such as your phone number or email address;</li>
        <li>address information – such as your physical or postal address; or</li>
        <li>demographic information – such as your gender or marital status.</li>
    </ul>
    <p>Depending on the goods or services you require, we may also collect sensitive personal information including
        your:</p>
    <ul class="list-disc list-inside ml-4">
        <li>sensitive demographic information – such as your race or ethnicity; and</li>
        <li>employment information – including your membership of a trade union.</li>
    </ul>

    <h2 class="text-2xl font-semibold mt-6">4. Acceptance, legal capacity, and your obligations</h2>
    <h3 class="text-lg font-semibold">Acceptance required</h3>
    <p>You must accept all the terms of this policy when you order our goods or request our services. If you do not
        agree with anything in this policy, then you may not order our goods or request our services.</p>
    <h3 class="text-lg font-semibold">Deemed acceptance</h3>
    <p>By accepting this policy, ordering our goods, or requesting our services, we deem you to have read, understood,
        accepted, and agreed to be bound by all of its terms.</p>
    <h3 class="text-lg font-semibold">Legal capacity</h3>
    <p>You may not access our website or order our goods or request our services if you are younger than 18 years old or
        do not have legal capacity to conclude legally binding contracts.</p>
    <h3 class="text-lg font-semibold">Your obligations</h3>
    <p>You may only send us your personal information or of another data subject where you have their permission to do
        so.</p>

    <h2 class="text-2xl font-semibold mt-6">5. How do we collect personal information?</h2>
    <ul class="list-disc list-inside ml-4">
        <li><strong>On registration:</strong> When you submit an enquiry or if you register on our website, you will no
            longer be anonymous to us.</li>
        <li><strong>On order or request:</strong> You will be asked to provide us with additional information on a
            voluntary basis (goods or services information).</li>
        <li><strong>Events:</strong> You will provide us with personal information when you attend an event that we
            host.</li>
        <li><strong>From browser:</strong> We automatically receive and record Internet usage information on our server
            logs from your browser, such as your IP address, browser type, click patterns, etc.</li>
        <li><strong>Cookies:</strong> Please refer to our Cookies Policy for details.</li>
        <li><strong>Web beacons:</strong> We use them to compile anonymous information about our website. They do not
            collect personal information.</li>
    </ul>

    <h3 class="text-lg font-semibold">Optional details</h3>
    <p>You may also provide additional information to us on a voluntary basis. This includes content you upload,
        responses to surveys, or requests for additional services.</p>

    <h3 class="text-lg font-semibold">Recording calls</h3>
    <p>We may monitor and record any telephone calls that you make to us, unless you specifically request us not to do
        so.</p>
    <h2 class="text-2xl font-semibold mt-6">6. Purpose for processing</h2>
    <p>We may use or process any goods or services information, or optional information that you provide to us for the
        purposes that you indicated when you agreed to provide it to us. Processing includes gathering your personal
        information, disclosing it, and combining it with other personal information. We generally collect and process
        your personal information for various purposes, including:</p>
    <ul class="list-disc list-inside ml-4">
        <li>goods or services purposes – such as collecting orders or requests for and providing our goods or services;
        </li>
        <li>marketing purposes – such as pursuing lawful related marketing activities;</li>
        <li>business purposes – such as internal audit, accounting, business planning, and joint ventures, disposals of
            business, or other proposed and actual transactions;</li>
        <li>legal purposes – such as handling claims, complying with regulations, or pursuing good governance.</li>
    </ul>
    <p>We may use your usage information for the purposes described above and to:</p>
    <ul class="list-disc list-inside ml-4">
        <li>remember your information so that you will not have to re-enter it during your visit or when you next access
            the website;</li>
        <li>monitor website usage metrics such as total number of visitors and pages accessed;</li>
        <li>track your entries, submissions, and status in any promotions or other activities in connection with your
            use of the website.</li>
    </ul>
    <p><strong>Consent to collection</strong></p>
    <p>If the law requires, we will obtain your consent to collect personal information:</p>
    <ul class="list-disc list-inside ml-4">
        <li>in accordance with applicable law; or</li>
        <li>when you provide us with any registration information or optional information.</li>
    </ul>
    <h2 class="text-2xl font-semibold mt-6">7. Use</h2>
    <p><strong>Our obligations</strong></p>
    <p>We may use your personal information to fulfil our obligations to you.</p>

    <p><strong>Messages and updates</strong></p>
    <p>We may send administrative messages and email updates to you about the website. In some cases, we may also send
        you primarily promotional messages. You can choose to opt-out of promotional messages.</p>

    <p><strong>Targeted content</strong></p>
    <p>While you are logged into the website, we may display targeted adverts and other relevant information based on
        your personal information. In a completely automated process, computers process the personal information and
        match it to adverts or related information. We never share personal information with any advertiser unless you
        specifically provide us with your consent to do so.</p>
    <p>Advertisers receive a record of the total number of impressions and clicks for each advert. They do not receive
        any personal information. If you click on an advert, we may send a referring URL to the advertiser’s website
        identifying that a customer is visiting from the website. We do not send personal information to advertisers
        with the referring URL. Once you are on the advertiser’s website, however, the advertiser can collect your
        personal information. We are not responsible for the event where they collect personal information.</p>
    <h2 class="text-2xl font-semibold mt-6">8. Reasons we share personal information</h2>
    <p>We may share your personal information with:</p>
    <ul class="list-disc list-inside ml-4">
        <li>other divisions or companies within the group of companies to which we belong:
            <ul class="list-disc list-inside ml-6">
                <li>to provide joint content and services like registration,</li>
                <li>for transactions and customer support,</li>
                <li>to help detect and prevent potentially illegal acts and violations of our policies, and</li>
                <li>to guide decisions about our products, services, and communications (they will only use this
                    information to send you marketing communications if you have requested their goods or
                    services);</li>
            </ul>
        </li>
        <li>an affiliate, in which case we will—if possible—require the affiliates to honour this privacy policy;</li>
        <li>our goods or services providers under contract who help provide certain goods or services or help
            with parts of our business operations, including fraud prevention, bill collection, marketing,
            technology services (our contracts dictate that these goods or services providers only use your
            information in connection with the goods or services they supply or services they perform for us and
            not for their own benefit);</li>
        <li>credit bureaus to report account information, as permitted by law;</li>
        <li>banking partners as required by credit card association rules for inclusion on their list of terminated
            merchants (if you utilise the services to receive payments and you meet their criteria); and</li>
        <li>other third parties who provide us with relevant services where appropriate.</li>
    </ul>

    <h3 class="text-lg font-semibold mt-4">Regulators</h3>
    <p>We may disclose your personal information as required by law or governmental audit.</p>

    <h3 class="text-lg font-semibold mt-4">Law enforcement</h3>
    <p>We may disclose personal information if required:</p>
    <ul class="list-disc list-inside ml-4">
        <li>by a subpoena or court order;</li>
        <li>to comply with any law;</li>
        <li>to protect the safety of any individual or the general public; and</li>
        <li>to prevent violation of any of our legal terms.</li>
    </ul>

    <h3 class="text-lg font-semibold mt-4">No selling</h3>
    <p>We will not sell personal information or disclose it to anyone except as provided in this policy.</p>

    <h3 class="text-lg font-semibold mt-4">Marketing purposes</h3>
    <p>We may disclose aggregate statistics (information about the website visitor, prospect, or customer
        population in general terms) about the personal information to advertisers or business partners.</p>

    <h3 class="text-lg font-semibold mt-4">Personnel</h3>
    <p>We may need to disclose personal information to our personnel that require the personal information to
        do their jobs. These include our management, human resources, accounting, audit, compliance,
        information technology, or other personnel.</p>

    <h3 class="text-lg font-semibold mt-4">Change of ownership</h3>
    <p>If we undergo a change in ownership, or a merger with, acquisition by, or sale of assets to, another entity,
        we may assign our rights to the personal information we process to a successor, purchaser, or separate
        entity. We may disclose the transfer on the website. If you are concerned about your personal information
        migrating to a new owner, you may ask us to delete your personal information.</p>

    <h2 class="text-2xl font-semibold mt-6">9. Security</h2>
    <p>We take the security of personal information very seriously and always do our best to comply with
        applicable data protection laws. Our hosting company will host our website in a secure server
        environment that uses a firewall and other advanced security measures to prevent interference or access
        from outside intruders. We implement disaster recovery procedures where appropriate.</p>

    <h2 class="text-2xl font-semibold mt-6">10. Accurate and up to date</h2>
    <p>We will try to keep the personal information we collect as accurate, complete and up to date as is
        necessary for the purposes defined in this policy. From time to time, we may ask you to update your
        personal information via the website. You can review or update any personal information that we hold on
        you (or third parties that you have lawfully and permissibly provided to us) by accessing your account
        online, emailing us, or phoning us. Please note that to protect you better and safeguard your personal
        information, we take steps to verify your identity before granting you access to your account or making
        any corrections to personal information.</p>

    <h2 class="text-2xl font-semibold mt-6">11. Retention</h2>
    <p>We will only retain your personal information for as long as it is necessary to fulfil the purposes explicitly
        set out in this policy, unless:</p>
    <ul class="list-disc list-inside ml-4">
        <li>retention of the record is allowed, required, or authorised by law; or</li>
        <li>you have consented to the retention of the record.</li>
    </ul>
    <p>During retention, we will continue to abide by our non-disclosure obligations and will not sell your
        personal information.</p>
    <p>We may retain your personal information in physical or electronic records at our discretion.</p>

    <h2 class="text-2xl font-semibold mt-6">12. Transfer to another country</h2>
    <p>We may transmit or transfer personal information outside of the country in which it was collected to a
        foreign country and process it in that country. Personal information may be stored on servers located
        outside the country in which it was collected. The storage destination may be a foreign country whose
        personal information laws may not be as stringent as the laws in the country in which it was collected. We
        will obtain your consent where we intend to transfer your personal information across a country border.</p>

    <h2 class="text-2xl font-semibold mt-6">13. Your rights</h2>
    <h3 class="text-lg font-semibold mt-4">Request what information we hold on you</h3>
    <p>You may request access to your personal information to receive a copy of the personal information that
        we hold on you.</p>

    <h3 class="text-lg font-semibold mt-4">Updating or removing</h3>
    <p>You may choose to correct or update the personal information you have submitted to us, by clicking the
        relevant menu in any of the pages on our website or contacting us by phone or email.</p>

    <h3 class="text-lg font-semibold mt-4">Withdrawal of consent or objection to processing</h3>
    <p>You may withdraw your consent where we are relying on consent as a lawful justification to process. You
        may also object to our processing where we are relying on another lawful justification for processing.
        Please note that if you do so, we might not be able to provide goods or services to you.</p>
    <p>We may need to request additional information from you to verify your identity for you to access these
        rights. This measure is to ensure that your personal information is not disclosed to an unauthorised
        person.</p>


    <h2 class="text-2xl font-semibold mt-6">14. Changes</h2>
    <p>We may change the terms of this policy at any time by updating this web page. We will notify you of any
        changes by placing a notice in a prominent place on the website or by sending you an email detailing the
        changes that we have made and indicating the date that they were last updated.</p>
    <p>If you do not agree with the changes, then you must stop using the website and our goods or services. If
        you continue to use the website or our goods or services following notification of a change to the terms,
        the changed terms will apply to you and we will deem you to have accepted the updated terms.</p>

    <h2 class="text-2xl font-semibold mt-6">15. Limitation</h2>
    <p>We are not responsible for, give no warranties, nor make any representations in respect of the privacy
        policies or practices of linked or any third-party websites.</p>

    <h2 class="text-2xl font-semibold mt-6">16. Enquiries</h2>
    <p>If you have any questions or concerns arising from this privacy policy or the way in which we handle
        personal information, please contact us via <a href="mailto:privacy@regardingmylife.com"
            class="text-blue-600 underline">privacy@regardingmylife.com</a>.</p>


</div>